(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["exo-contact-button"] && !Shopify.designMode) return;
  try {
    (() => {
    const widget = document.getElementById('exo-contact-widget');
    if (!widget) return;
    const dialog = widget.querySelector('dialog');
    const trigger = widget.querySelector('.exo-contact-tab');
    trigger.addEventListener('click', () => dialog.showModal());
    widget.querySelector('.exo-contact-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => trigger.focus());
    if (dialog.querySelector('[data-exo-result]')) dialog.showModal();
  })();
  } catch(e) { console.error(e); }
})();

})();
